import { useMutation } from '@tanstack/react-query';

import type { FileFormSchema, FileQuerySchema } from '@/_schemas/file';
import type { ApiError } from '@/_shared';
import { apiClient } from '@/_shared';

export const useCreateFileMutation = () =>
  useMutation<{ data: FileQuerySchema }, ApiError, FileFormSchema & { isNew?: boolean }>({
    mutationFn: ({ access_level, media, folder_path, name }) => {
      const payload = new FormData();
      payload.append('name', name || '');
      payload.append('access_level', access_level || '');
      payload.append('folder_path', folder_path || '');
      payload.append('media', media, media.name);

      return apiClient.request({
        endpoint: '/api/v1/media',
        payload,
        isUpload: true,
        // onUploadProgress: (progress, rawProgress) => {
        //   if (!isNew) {
        //     if (toast === null) {
        //       toast = snackbar.info(`Uploading Image`, { toastId: 'IMAGE_UPLOAD', progress: rawProgress });
        //     } else {
        //       snackbar.update(toast, { progress: rawProgress });
        //     }
        //   }
        // },
        init: {
          headers: {
            Accept: 'application/json',
          },
        },
      });
    },
  });

export const useUpdateFileMutation = () =>
  useMutation<{ data: FileQuerySchema }, ApiError, FileFormSchema & { id: string }>({
    mutationFn: ({ id, ...rest }) =>
      apiClient.request({
        endpoint: `/api/v1/media/${id}`,
        method: 'PUT',
        payload: rest,
      }),
  });

export const useDeleteFileMutation = () =>
  useMutation<unknown, unknown, { id: string }>({
    mutationKey: ['IMAGE_DELETE'],
    mutationFn: ({ id }) =>
      apiClient.request({
        endpoint: `/api/v1/media/${id}`,
        method: 'DELETE',
      }),
  });
